import React, { useReducer } from "react";
import { setStorage, getStorage } from "../utilities";

const storageKey = "latency-tests";

// The initial state settings.
const initialState = {
  times: null, // Array of test times.
  testCount: 0,
  averageLatency: 0,
  maximumLatency: 0,
  minimumLatency: 0,
};

/** Initialize state.
 *
 */
const initState = () => {
  // Load from local storage if any.
  let state = getStorage(storageKey);
  if (!state) {
    state = { ...initialState };
  }

  return state;
};

/** Calculate the stats.
 *
 */
const calculateStats = (state) => {
  let sum = 0;
  let count = 0;
  let minimum = 0;
  let maximum = 0;

  state.times.forEach((tests) => {
    if (tests && Array.isArray(tests)) {
      tests.forEach((test) => {
        if (count === 0) {
          // First time so set initial stats.
          minimum = test;
          maximum = test;
        } else {
          // Not first so test for max and min.
          if (test > maximum) maximum = test;
          if (test < minimum) minimum = test;
        }
        sum += test;
        count++;
      });
    }
  });

  state.testCount = count;

  if (count > 0) {
    state.averageLatency = sum / count;
  }
  state.minimumLatency = minimum;
  state.maximumLatency = maximum;

  return state;
};

/** Reset the entire state.
 *
 */
const resetAll = (state) => {
  return initialState;
};

/** Reset one test set.
 *
 */
const resetOne = (state, index) => {
  // console.log(`resetting one ${index}`);
  let newState = state;

  //newState.times = [...state.times];

  if (!newState.times) {
    newState.times = [];
  }

  newState.times[index] = [];

  // Recalculate all the stats.
  return calculateStats(newState);
};

// The Reducer ---------------------------------------------------------------------------------------------------------

// Action
//  type = "reset", "append"
//  payload = { index, test, tests }

const reducer = (state, action) => {
  let newState = { ...initialState };

  if (!action) {
    return state;
  }

  switch (action.type) {
    case "reset":
      // Reset one or all tests depending on whether an index is passed.
      if (typeof action.index === "number") {
        // Reset one.
        newState = resetOne(state, action.index);
      } else {
        // Reset all.
        newState = resetAll(state);
      }
      break;

    case "append":
      newState = { ...initialState };

      if (state.times) {
        newState.times = [...state.times];
      } else {
        newState.times = [];
      }

      if (!Array.isArray(newState.times[action.index])) {
        newState.times[action.index] = [];
      }

      if (action.replace) {
        if (Array.isArray(action.tests)) {
          newState.times[action.index] = [...action.tests];
        } else {
          newState.times[action.index] = [action.tests];
        }
      } else {
        if (Array.isArray(action.tests)) {
          newState.times[action.index] = [...newState.times[action.index], ...action.tests];
        } else {
          newState.times[action.index] = [...newState.times[action.index], action.tests];
        }
      }
      // Calculate the stats on the new tests.
      newState = calculateStats(newState);
      break;

    default:
      newState = state;
    //      return state;
  }

  setStorage(storageKey, newState);

  return newState;
};

// The Context ---------------------------------------------------------------------------------------------------------

export const TestsContext = React.createContext();

/** The Context Provider.
 *
 *  @param {} props
 */
export const TestsContextProvider = (props) => {
  const [tests, dispatch] = useReducer(reducer, initState());
  return <TestsContext.Provider value={{ tests, dispatch }}>{props.children}</TestsContext.Provider>;
};
